export class Globals {
  //static SERVER_ADDR = 'https://analytics-cosy.com/server';
  static SERVER_ADDR = 'https://cosywifi.co.uk/server';

  static TOKEN: string;
  static COOKIES_TOKEN = 'yw_cpb_token';
  static COOKIES_CLIENT_ID = 'client_id';
  static COOKIES_DASHBOARD_PARAMS = 'dash_params';
  static RESPONSE_RESULT_SUCCESS = 'OK';
  static RESPONSE_RESULT_ERROR = 'I_AM_A_TEAPOT';
  static RESPONSE_RESULT_UNAUTHORIZED = 'UNAUTHORIZED';
  static INTERNAL_SERVER_ERROR = '500';
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/globals/Globals.ts